import { LitElement, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import '@maersk-global/mds-components-core'
import { mapDownloadPopupStyles } from '../../styles/map-download-popup-styles'

export enum MapDownloadPopupEventNames {
    CancelMapDownload = 'cancel-map-download',
}

@customElement('map-download-popup')
export class MapDownloadPopup extends LitElement {
    @property({ type: Number }) progress: number = 0

    static styles = mapDownloadPopupStyles

    render() {
        return html`
            <mc-modal
                heading="Download Offline Map"
                zindex="99999"
                maxWidth="635px"
                height="370px"
                hiddenclose
                backdropcloseactiondisabled
                escapecloseactiondisabled
                entercloseactiondisabled
                ?open=${true}
            >
                <div class="loading-container">
                    <img
                        src="./assets/images/ship-loader.gif"
                        class="loading-img"
                    />

                    <p class="loading-primary">
                        <span class="progress-value">${this.progress}%</span>
                        completed
                    </p>
                    <p class="loading-secondary">
                        Please wait while we download offline map for you...
                    </p>
                </div>
                <mc-button
                    slot="secondaryAction"
                    appearance="neutral"
                    variant="filled"
                    fit="small"
                    @click="${() => {
                        this.dispatchEvent(
                            new CustomEvent(
                                MapDownloadPopupEventNames.CancelMapDownload,
                                {
                                    bubbles: true,
                                    composed: true,
                                },
                            ),
                        )
                    }}"
                >
                    Cancel
                </mc-button>
            </mc-modal>
        `
    }
}
